// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607160304/js/" + chunkId + "." + {"44":"7f864a0e","225":"f57e21d6","481":"f2b479b8","486":"0a56efab","770":"09f09706"}[chunkId] + ".0.5585554162105255.chunk.js";
};